export const theme = {
  fontFamily: "Inter, sans-serif",
  fontSize: "14px",
  primaryColor: "#39f",
  secondaryTextColor: "#39f",
  color: {
    primary: "#141414",
    secondary: "#cccccc",//color Loading
    darkSecondary: "#eaeaea",
    grey: "rgba(20,20,20,0.04)",
    helpText: "#fff",//text of system added... or system info in groups
    startMessagingText: "#FF8A00",
    blue: "#39f",
    strongBlue: "rgb(7,95,184)",
    white: "#fff",//color user text
    red: "#ff3b30",
  },
  borderColor: {
    primary: "#eaeaea",
    secondary: "#cccccc",
    darkSecondary: "#eaeaea",
    white: "#fff",
    blue: "#39f",
  },
  backgroundColor: {
    white: "#fff",
    primary: "#E6E6E6",
    secondary: "#f6f6f6",
    blue: "#39f",
    darkBlue :"#0458E2",
    red: "#ff3b30",
    grey: "rgba(20,20,20,0.04)",
    lightGrey: "rgba(20, 20, 20, 0.08)",
    darkGrey: "rgba(20,20,20,0.9)",
    callScreenGrey: "#444444",
    silver: "#c4c4c4",
    WrapperRecivedColor:"#FF8A00"
  },
  breakPoints: ["(min-width: 320px) and (max-width: 767px)"],
};
